import { PatientSearchOptionWithBirthDate } from '../../../../../common/enums/patientSearchOptionWithBirthDate';
import { TextInput } from '../../../fields/Text';

export function PatientSearchOtherOptionsFormFields(props: { searchOption: PatientSearchOptionWithBirthDate }) {
    if (props.searchOption === PatientSearchOptionWithBirthDate.identifierSocialSecurity) {
        return <TextInput fieldKey="identifierSocialSecurity" />;
    } else if (props.searchOption === PatientSearchOptionWithBirthDate.insurance) {
        return <TextInput fieldKey="insurancePolicyNumber" />;
    } else if (props.searchOption === PatientSearchOptionWithBirthDate.address) {
        return (
            <>
                <TextInput fieldKey="zip" />
                <TextInput fieldKey="houseNumber" />
            </>
        );
    } else {
        return null;
    }
}
